import type {
  RiderSaleStatus,
  SalePaymentMethod,
} from "@artisancode/api-types";

export const RIDER_SALE_PAYMENT_METHOD_LABELS: Record<
  SalePaymentMethod,
  string
> = {
  cash: "Tunai",
  edc: "EDC",
  qris: "QRIS",
  app_qris: "App QRIS",
  bank_transfer: "Transfer",
  credit_unpaid: "Kasbon/Belum Bayar",
};

export const RIDER_SALE_STATUS_LABELS: Record<RiderSaleStatus, string> = {
  draft: "Draft",
  done: "Done",
  paid: "Paid",
  cancelled: "Dibatalkan",
};

export const RIDER_SALE_STATUS_BADGE_VARIANT: Record<
  RiderSaleStatus,
  "default" | "secondary" | "outline" | "destructive"
> = {
  draft: "outline",
  done: "secondary",
  paid: "default",
  cancelled: "destructive",
};

// Mirrors api/src/modules/rider_sale/rider_sale.lifecycle.ts — forward-only
// workflow (paid/done never silently drop back to draft). Kept here instead
// of a free-form status picker so the UI can only ever offer valid next
// steps, not just reject invalid ones after the fact. "cancelled" is never
// offered here — it's only reachable via the dedicated Void action (see
// rider-sale-list.tsx), which requires a reason.
export const RIDER_SALE_STATUS_NEXT: Record<
  RiderSaleStatus,
  readonly RiderSaleStatus[]
> = {
  draft: ["done"],
  done: ["paid"],
  paid: [],
  cancelled: [],
};
